import React from 'react';
import { Dialog, DialogTitle, DialogContent, Box, Typography } from '@mui/material';
import useSentFeedbacksService from 'domain/people/employeePortal/feedback/useSentFeedbacksService';
import useFeedbackRegistry from 'domain/people/employeePortal/feedback/FeedbackRegistry';
import { Timeline, TimelineLayout } from 'framework/ui/timeline';
import { EmployeeFilter } from 'domain/shared/employee';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { Filters, FiltersLayout, ListPageLayout } from 'framework/list';

interface GivenFeedbackModalProps {
  open: boolean;
  onClose: () => void;
}

const GivenFeedbackModal: React.FC<GivenFeedbackModalProps> = ({ open, onClose }) => {
  const { search } = useSentFeedbacksService();
  const feedbackRegistry = useFeedbackRegistry();
  const scrollableContainerRef = React.useRef<HTMLDivElement>(null);

  const filter = (
    <Filters>
      <FiltersLayout>
        <EmployeeFilter source="feedback.employee.alias" label="Worker" />
      </FiltersLayout>
    </Filters>
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h3" color="textPrimary">
            All feedback I left
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ height: '70vh', padding: 0, overflow: 'auto', mx: 3 }} ref={scrollableContainerRef}>
        <Timeline
          registries={[feedbackRegistry] as any}
          getDataMethod={request => search(request)}
          useWindow={false}
          scrollableContainer={scrollableContainerRef}
        >
          <ListPageLayout showTotal={false} filter={filter} sxPaper={{ p: '0!important' }}>
            <TimelineLayout noEntriesMessage="You haven't left any Instant Feedback yet" />
          </ListPageLayout>
        </Timeline>
      </DialogContent>
    </Dialog>
  );
};

export default GivenFeedbackModal;
